import { Box, Container, Header, Icon, KeyValuePairs } from '@amzn/awsui-components-core';
import React from 'react';
import {
  BarRaiserDashboardInfo,
  TechDomain,
  TechDomainDisplayNames,
} from '@amzn/awscat-pattern-library-service-model';

interface BarRaiserDashboardOverviewProps {
  techDomain: string;
  dashboardOverview: BarRaiserDashboardInfo;
}

export const BarRaiserDashboardOverview = (props: BarRaiserDashboardOverviewProps) => {
  const { techDomain, dashboardOverview } = props;
  const { totalCount, publisherCount, nearSLACount, pastSLACount } = dashboardOverview;

  return (
    <Container
      variant="stacked"
      header={
        <Header
          variant="h3"
          counter={'(' + totalCount.toString() + ')'}
          description="Active and open reviews"
        >
          {/* @ts-expect-error TS7053 - strict migration */}
          {TechDomainDisplayNames.get(TechDomain[techDomain])} bar raiser overview
        </Header>
      }
      fitHeight
    >
      <KeyValuePairs
        columns={3}
        items={[
          { label: 'Publisher reviews', value: <Box variant="h2">{publisherCount}</Box> },
          {
            label: 'Approaching due date',
            value: (
              <Box color="text-status-warning" variant="h2">
                <Icon name="status-warning" size="big" variant="warning" />
                &nbsp;{nearSLACount}
              </Box>
            ),
          },
          {
            label: 'Overdue',
            value: (
              <Box color="text-status-error" variant="h2">
                <Icon name="status-negative" size="big" variant="error" />
                &nbsp;{pastSLACount}
              </Box>
            ),
          },
        ]}
      />
    </Container>
  );
};
